const toggleNotAttending = function(boolean) {
  const attending = $(boolean)
  const notAttending = attending.parents('.form-group').next('.not-attending')
  notAttending.toggle(attending.val() == 'false')
}

const dateFromString = function(string) {
  let array = string.split('-').map(x => parseInt(x))
  array[1] -= 1
  return new Date(...array)
}

const getDateFromFields = function(el) {
  return [1, 2, 3].map(n => el.querySelector(`select[id$="${n}i"]`).value).join('-')
}

const calcAge = function(el) {
  const birthDate = dateFromString(getDateFromFields(el))
  if (isNaN(birthDate.getFullYear()))
    return -1

  const feastEnd = dateFromString($('form.registration.personal .people').attr('data-feast-end'))
  let years = feastEnd.getFullYear() - birthDate.getFullYear()

  if (birthDate.getMonth() > feastEnd.getMonth())
    years -= 1
  if (birthDate.getMonth() == feastEnd.getMonth() && birthDate.getDate() > feastEnd.getDate())
    years -= 1

  return years
}

const toggleAgeAndNameBadge = function() {
  $('form.registration.personal .well').each(function() {

    const container = this.querySelector('.registration_active_people_birth_date')
    const age = calcAge(container)
    if (age >= 0)
      container.querySelector('label').innerText = `Birth date (age ${age} at Feast)`

    const msg = age >= 18 ? 'Name <span class="text-danger">(as it will appear on your name badge)</span>' : 'Name'
    this.querySelector('.registration_active_people_name label').innerHTML = msg
  })
}

$(document).on('change', 'form.registration.personal .attending', function() {
  toggleNotAttending(this)
})

$(document).on('change', 'form.registration.personal .registration_active_people_birth_date select', function() {
  toggleAgeAndNameBadge()
})

$(function() {
  toggleAgeAndNameBadge()
  $('form.registration.personal .attending').each((i, el) => toggleNotAttending(el))
})
